import React from "react";
import styles from "../../assets/scss/pagesScss/home.module.scss";
import { projects } from "../../assets/config/config";
import { Link } from "react-router-dom";


const ProjectSection = () => {
    return (
        <section>
            <div className="container">
                <div className={styles.projectsSection}>
                    <div className={styles.header}>
                        <div>
                            <h3 className={styles.subtitle}>OUR PROJECTS</h3>
                            <h2 className={styles.title}>Powering The Future With Smart Projects</h2>

                        </div>
                        <p className={styles.description}>
                            From residential households to commercial enterprises, we provide
                            reliable, efficient, and sustainable energy solutions.
                        </p>

                    </div>
                    <div className={styles.seeAll}>
                        <Link to="/projects" className={styles.link}>See All </Link>
                    </div>
                    <div className={styles.projectsGrid}>
                        {projects.slice(0, 4).map((project) => (
                            <div key={project.id} className={styles.projectCard} onClick={() => window.location.href = `/project/${project.id}`}>
                                <img src={project.thumbnail} alt={project.title} className={styles.image} />
                                <div className={styles.overlay}>
                                    <p className={styles.category}>{project.category}</p>
                                    <h4 className={styles.projectTitle}>{project.title}</h4>
                                </div>
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </section>
    );
};

export default ProjectSection;